import { Button, Form, Input, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  saveMonitoringQuery,
  updateMonitoringQuery,
} from '../../redux/actions/ioc';
import { incrementUIRequestsCounter } from '../../redux/utils/websocket/incrementUIRequestsCounter';

const Monitor = (props) => {
  const { monitorModalVisible, handleModalCancel, currentQuery, type } = props;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  useEffect(() => form.resetFields());

  useEffect(() => {
    if (
      props?.selectedMonitorToEdit &&
      Object.keys(props?.selectedMonitorToEdit)?.length > 0
    ) {
      form.setFieldsValue(loadInitialValues());
    }
  }, [props?.selectedMonitorToEdit]);

  const loadInitialValues = () => {
    let initialValues = {
      monitoring_name: props?.selectedMonitorToEdit?.name,
      monitor_description: props?.selectedMonitorToEdit?.description,
    };
    return initialValues;
  };

  return (
    <Modal
      footer={null}
      title={'Monitor Results'}
      visible={monitorModalVisible}
      onCancel={handleModalCancel}
      width="624px"
      bodyStyle={{ height: '344px' }}
    >
      <div>
        <Form
          form={form}
          name="explore"
          className="explore-form"
          onFinish={(values) => {
            let rawFrontendURL = new URL(window.location.href);
            let params = new URLSearchParams(rawFrontendURL.search);

            params.delete('recipe');
            params.delete('row');
            params.delete('enrichQuery');
            params.delete('fromMonitoring');
            params.delete('nsChangeQuery');
            params.delete('fromMonitoring');

            let trimmedURL =
              rawFrontendURL?.origin +
              rawFrontendURL?.pathname +
              '?' +
              params.toString();

            let currentQueryToSave =
              type === 'anyIP'
                ? currentQuery
                    ?.toString()
                    ?.replace('padns/lookup/query/', '')
                    ?.replace('PTR4', 'anyIP')
                    ?.replace('limit=100', 'limit=1000')
                : currentQuery?.replace('limit=100', 'limit=1000');

            let monitoringURLToSave = new URL(
              currentQueryToSave,
              'https://silentpush.com',
            );
            let monitoringURLParams = new URLSearchParams(
              monitoringURLToSave.search,
            );

            monitoringURLParams.delete('first_seen_before');
            monitoringURLParams.delete('first_seen_after');

            let finalMonitoringURLPathName =
              monitoringURLToSave?.pathname?.toString()?.charAt(0) === '/'
                ? monitoringURLToSave?.pathname?.substring(1)
                : monitoringURLToSave?.pathname;
            // console.log(finalMonitoringURLPathName + '?' + monitoringURLParams)
            let assembledURLToSaveForMonitoring =
              finalMonitoringURLPathName +
              '?' +
              monitoringURLParams?.toString();
            // console.log(assembledURLToSaveForMonitoring)
            if (
              props?.selectedMonitorToEdit &&
              Object.keys(props?.selectedMonitorToEdit).length > 0
            ) {
              dispatch(
                updateMonitoringQuery({
                  uuid: props?.selectedMonitorToEdit?.uuid,
                  name: values?.monitoring_name,
                  description: values?.monitor_description,
                }),
              );
              incrementUIRequestsCounter();
            } else {
              dispatch(
                saveMonitoringQuery({
                  name: values?.monitoring_name,
                  description: values?.monitor_description,
                  origin: props?.origin_uid,
                  scope: 'USER',
                  frontend_url: trimmedURL,
                  url: assembledURLToSaveForMonitoring,
                  actions: ['SEND_EMAIL'],
                }),
              );
              incrementUIRequestsCounter();
            }
            handleModalCancel();
          }}
        >
          <div>
            <p
              style={{
                position: 'absolute',
                top: '64px',
                left: '24px',
                color: 'rgba(255, 255, 255, 0.85)',
                fontSize: '14px',
              }}
            >
              Set a monitor to run this query once every 24 hours. You will be
              alerted when Silent Push detects new results via email. Any
              filtering/sorting/selection is currently disregarded.
            </p>
          </div>

          <div
            style={{
              position: 'absolute',
              top: '140px',
              left: '16px',
            }}
          >
            <p
              style={{
                position: 'absolute',
                top: '-24px',
                left: '8px',
                color: 'rgba(255, 255, 255, 0.85)',
                fontSize: '14px',
              }}
            >
              Monitor name
            </p>
            <Form.Item
              name="monitoring_name"
              rules={[
                {
                  required: true,
                  message: 'Please input the name for the monitor!',
                },
              ]}
            >
              <Input
                maxLength={40}
                style={{ width: '592px' }}
                placeholder="Enter the name for monitor"
              />
            </Form.Item>
          </div>

          <div
            style={{
              position: 'absolute',
              top: '210px',
              left: '16px',
            }}
          >
            <p
              style={{
                position: 'absolute',
                top: '-24px',
                left: '8px',
                color: 'rgba(255, 255, 255, 0.85)',
                fontSize: '14px',
              }}
            >
              Description
            </p>
            <Form.Item
              name="monitor_description"
              rules={[
                {
                  required: false,
                  message: 'Please input the description for the monitor!',
                },
              ]}
            >
              <Input.TextArea
                rows={4}
                maxLength={255}
                style={{
                  width: '592px',
                  minWidth: '592px',
                  maxWidth: '592px',
                }}
              />
            </Form.Item>
          </div>

          <Button
            style={{
              position: 'absolute',
              top: '346px',
              right: '100px',
              border: 'none',
            }}
            onClick={() => handleModalCancel()}
          >
            Cancel
          </Button>
          <Button
            style={{
              position: 'absolute',
              top: '346px',
              right: '16px',
            }}
            onClick={() => form?.submit()}
            type="primary"
          >
            Save
          </Button>
        </Form>
      </div>
    </Modal>
  );
};

export default Monitor;
